import {
  StyleSheet,
  TextInput,
  type StyleProp,
  type TextInputProps,
  type ViewStyle,
} from 'react-native';
import { tokens } from '../../theme/tokens';

type AppInputProps = TextInputProps & {
  containerStyle?: StyleProp<ViewStyle>;
};

export function AppInput({ style, placeholderTextColor, ...inputProps }: AppInputProps) {
  return (
    <TextInput
      {...inputProps}
      placeholderTextColor={placeholderTextColor ?? tokens.colors.textSubtle}
      style={[styles.input, style]}
    />
  );
}

const styles = StyleSheet.create({
  input: {
    minHeight: tokens.layout.inputHeight,
    borderRadius: tokens.radius.md,
    borderWidth: tokens.border.width,
    borderColor: tokens.colors.border,
    backgroundColor: tokens.colors.surface,
    color: tokens.colors.text,
    paddingHorizontal: tokens.spacing.lg,
    fontSize: tokens.fontSize.md,
    lineHeight: tokens.lineHeight.md,
  },
});
